import auth from './auth'
import bussinessUsers from './bussinessUsers';
import users from './users';
import offer from './offer';
import amenities from './amenities';
import keywords from './keywords';
import categories from './categories';
import complaint from './complaint';
import issueReport from './issueReport';
import updateListing from './updateListing';
import reviewList from './reviewList';
import bussinessReviews from './bussinessReviews';
import notification from './notification';

const dictionary = {
    auth,
    bussinessUsers,
    users,
    offer,
    amenities,
    keywords,
    categories,
    complaint,
    issueReport,
    updateListing,
    reviewList,
    bussinessReviews,
    notification
}
export default dictionary